import { useCallback, useEffect, useRef, useState } from "react";

/**
 * Generic column-resize behavior for table header cells.
 */
export function useColumnResize() {
  const [columnWidths, setColumnWidths] = useState({});
  const [resizing, setResizing] = useState(null);
  const tableRef = useRef(null);

  const handleMouseDown = useCallback((event, columnField) => {
    event.preventDefault();
    event.stopPropagation();
    setResizing({ field: columnField, startX: event.clientX });
  }, []);

  useEffect(() => {
    const handleMouseMove = (event) => {
      if (!resizing) return;

      const delta = event.clientX - resizing.startX;
      setColumnWidths((prev) => ({
        ...prev,
        [resizing.field]: Math.max(80, (prev[resizing.field] || 150) + delta),
      }));
      setResizing({ ...resizing, startX: event.clientX });
    };

    const handleMouseUp = () => {
      setResizing(null);
    };

    if (resizing) {
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    }

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [resizing]);

  return {
    tableRef,
    columnWidths,
    handleMouseDown,
  };
}
